module.exports = __webpack_public_path__ + "Flag-504.15dd9c200a373eedc692cb6f90529bc2.svg";